import CONSTANTS from "../constants/constants.js";

export default function () {
    let observer = null;
    let blocks = document.querySelectorAll("[data-lazy-block]");
    let options = {
        root: null,
        threshold: 0,
        rootMargin: CONSTANTS.observerGap,
    };
    const scrollTop = document.querySelector('.scroll-top')

    const loadImages = (target) => {
        target.querySelectorAll("img[data-src]").forEach((img) => (img.src = img.dataset.src));
    };
    const setTemporaryTransition = (e)=>{
        e.target.classList.remove('animating')
        e.target.removeEventListener('transitionend',setTemporaryTransition)
    }
    const fadeItems = (target) => {
        loadImages(target);
        if(target.classList.contains('hero')) {
            scrollTop.classList.add('hidden')
        } else {
            scrollTop.classList.remove('hidden')
        }
        target.querySelectorAll("[data-lazy]")?.forEach((element, index) => {
            setTimeout(() => {
                element.classList.add("lazy-animate", "animating");
                element.addEventListener('transitionend',setTemporaryTransition)
            }, element.dataset.lazyDelay || index * 200);
        });
    };
    const unfadeItems = () => {
        document
            .querySelectorAll("section [data-lazy]")
            ?.forEach((element) => element.classList.remove("lazy-animate"));
        reObserve();
    };
    const createObserver = () => {
        observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                fadeItems(entry.target);

                observer.unobserve(entry.target);
            });
        }, options);
        reObserve();
    };
    const reObserve = () => {
        blocks.forEach((block) => observer.observe(block));
    };

    const setEvents = () => {
        window.addEventListener("scroll", () => {
            if (window.scrollY) return;
            unfadeItems();
        });
    };

    createObserver();
    setEvents();
}
